import axios from "axios";
import Swal from "sweetalert2";
import { t } from "i18next";

// Saving one answer can fail — most often because the exam time ran out on the
// server (a background browser tab throttles the countdown, so the client can
// still think there is time). These failures used to be swallowed with a bare
// console.log, so the student saw their choice selected, the navigator marked
// the question "not answered", and nothing explained why. This surfaces the
// server's message; on a time-up rejection it also finishes the attempt and
// returns the student to the exam page, since the client timer clearly drifted.
export const reportAnswerError = (err, examId) => {
  const body = err?.response?.data;
  const message = body?.message || t("answer_not_saved");
  const confirm = {
    confirmButtonColor: "hsl(28 89% 63% / 1)",
    confirmButtonText: t("ok"),
  };

  if (body?.data?.time_over) {
    // close the attempt server-side (the drifted client timer never did) then
    // send them back to the exam list
    axios
      .post(`${process.env.REACT_APP_API_URL}/exam/submit-exam`, { exam_id: examId })
      .finally(() => {
        Swal.fire({ html: message, icon: "warning", ...confirm }).then(() => {
          window.location.href = `${window.location.origin}/exams/${examId}`;
        });
      });
    return;
  }

  Swal.fire({ html: message, icon: "error", ...confirm });
};

export default reportAnswerError;
